import { type PropsWithChildren } from "react";

import { Footer } from "@vega-core/components/Layout/Footer/Footer";

import { AuthHeader } from "./AuthHeader";
import { Banner } from "./Banner";

export const LoginLayout = ({
  children,
  portal,
}: PropsWithChildren & { portal: FrontendPortal }) => (
  <div className="min-h-dvh p-4 xl:p-12 flex gap-8 xl:gap-12 bg-background/auth/primary">
    <div className="flex-1 flex flex-col bg-background/auth/primary">
      <AuthHeader portal={portal} />
      <div className="flex flex-grow w-full flex-col justify-center  items-center">
        <div className="w-full max-w-lg md:max-w-xl h-full">{children}</div>
      </div>
      <Footer containerStyle="p-0" isLoggedIn={false} />
    </div>
    <div className="hidden md:flex md:w-56 lg:w-80 xl:w-1/2 justify-center items-center bg-background/auth/secondary rounded-lg">
      <Banner />
    </div>
  </div>
);

import { type FrontendPortal } from "@vega-api/generated/types/frontendPortal";
